<app-leveltwo [videos]="true" [pageName]="'Home Owners Exemption'">
  <div class="General">

      <h3>{{'hox.PageTitle'|translate}}</h3>
      <p [innerHTML]="'hox.Textv2'|translate"></p>
      <!-- <i><p [innerHTML]="'hox.Further'|translate"></p></i> -->
      <b><p [innerHTML]="'hox.Ifeligible2'|translate"></p></b>

      <p [innerHTML]="'hox.Disclaimer'|translate"></p>

      <p><b>Los Angeles County Assessor's Office</b><br>
      500 W. Temple St. Room 227<br>
      Los Angeles, CA 90012</p>
      <!-- <p [innerHTML]="'hox.Forthesecurity'|translate"></p>
      <p [innerHTML]="'hox.Formoreinfo'|translate"></p> -->
      <p [innerHTML]="'hox.Weapologize'|translate"></p>


      <!-- <p [innerHTML]="'hox.Completedforms'|translate"></p>
      <a href="mailto:assr-hox@assessor.lacounty.gov">ASSR-HOX@assessor.lacounty.gov</a><br><br>
      <p [innerHTML]="'hox.Youcanalsoreach'|translate"></p> -->
  <h4 [innerHTML]="'hox.Versusv2'|translate"></h4>
  <p [innerHTML]="'hox.Statutory'|translate"></p>
  <p [innerHTML]="'hox.HomesteadExemptionv2'|translate"></p>
  <!-- <p [innerHTML]="'hox.FilingInfo'|translate"></p> -->

  </div>
  <app-videos-grid class="Videos" [videos]="videos"></app-videos-grid>
</app-leveltwo>
